import { createContext, FC, useCallback, useContext, useState } from 'react';
import { PageView } from '../../../models/analytics';
import { useUrlQuery } from '../UrlQueryProvider/UrlQueryProvider';

export type LegalContextProps = {
  hasUserReadLegalDisclaimer: (pageView: PageView) => boolean;
  setLegalDisclaimerPageView: (pageView: PageView) => void;
};

export const LegalContext = createContext<LegalContextProps>({
  hasUserReadLegalDisclaimer: () => false,
  setLegalDisclaimerPageView: () => null,
});

export const LegalProvider: FC = ({ children }) => {
  const { credentialsIdFromTPP } = useUrlQuery();
  const [legalDisclaimerPageView, setLegalDisclaimerPageView] = useState<PageView | undefined>(
    credentialsIdFromTPP ? PageView.CONSENT_SCREEN : undefined
  );

  const hasUserReadLegalDisclaimer = useCallback(
    // We consider LegalDisclaimer read when the user has been exposed to it and continued to another page
    (pageView): boolean => Boolean(legalDisclaimerPageView) && pageView !== legalDisclaimerPageView,
    [legalDisclaimerPageView]
  );

  return (
    <LegalContext.Provider
      value={{
        hasUserReadLegalDisclaimer,
        setLegalDisclaimerPageView,
      }}
    >
      {children}
    </LegalContext.Provider>
  );
};

export const useLegal = () => useContext(LegalContext);
